export const PERMISSIONS = {
  USER: {
    VIEW: 'user:view',
    SEARCH: 'user:search',
    CREATE: 'user:create',
    UPDATE: 'user:update',
    DELETE: 'user:delete',
  },
  ROLE: {
    VIEW: 'role:view',
    SEARCH: 'role:search',
    CREATE: 'role:create',
    UPDATE: 'role:update',
    DELETE: 'role:delete',
  },
  COMPANY: {
    VIEW: 'company:view',
    SEARCH: 'company:search',
    CREATE: 'company:create',
    UPDATE: 'company:update',
    DELETE: 'company:delete',
  },
  DEPARTMENT: {
    VIEW: 'department:view',
    SEARCH: 'department:search',
    CREATE: 'department:create',
    UPDATE: 'department:update',
    DELETE: 'department:delete',
  },
  APPLICATION: {
    VIEW: 'application:view',
    SEARCH: 'application:search',
    CREATE: 'application:create',
    UPDATE: 'application:update',
    DELETE: 'application:delete',
  },
  REPORT: {
    VIEW: 'report:view',
    SEARCH: 'report:search',
    CREATE: 'report:create',
    UPDATE: 'report:update',
    DELETE: 'report:delete',
  },
  MODULE: {
    VIEW: 'module:view',
    SEARCH: 'module:search',
    CREATE: 'module:create',
    UPDATE: 'module:update',
    DELETE: 'module:delete',
  },
  THEME: {
    UPDATE: 'theme:update',
  },
  LOG: {
    SEARCH: 'log:search',
  },
  REPORT_FILTER: {
    VIEW: 'report_filter:view',
    SEARCH: 'report_filter:search',
    CREATE: 'report_filter:create',
    UPDATE: 'report_filter:update',
    DELETE: 'report_filter:delete',
  },
  CHATBOT: {
    VIEW: 'chatbot:view',
    SEARCH: 'chatbot:search',
    CREATE: 'chatbot:create',
    UPDATE: 'chatbot:update',
    DELETE: 'chatbot:delete',
  },
} as const;
